import { Pipe, PipeTransform } from '@angular/core';
import { localeValueKey, LocaleValuesService } from '../services/locale.values.service';
import { SafeHtml } from '@angular/platform-browser';

/**
 * Pipe that transforms a localization key into its corresponding localized value,
 * applying placeholder substitution based on the provided fields.
 *
 * @example
 * // In the component template:
 * {{ 'greeting.message' | localeValue:[{ userName: 'Joel' }] }}
 * // If the localized value is: "Hello, {{userName}}"
 * // Result: "Hello, Joel"
 */
@Pipe({
  name: 'localeValue',
  pure: true, // Set to false if values may change reactively,
  standalone: false
})
export class LocaleValuePipe implements PipeTransform {

  constructor(private localeValuesService: LocaleValuesService) {
  }

  /**
   * Transforms a localization key into a localized string with placeholders replaced.
   *
   * @param key - The localization key.
   * @param fields - Optional array of field objects for substitution.
   * @returns The localized and formatted string.
   */
  transform(key: localeValueKey, fields?: Record<string, any>[]): SafeHtml {
    return this.localeValuesService.getLocaleValue(key, fields);
  }
}

